import { render, staticRenderFns } from "./QRCodeScannerForInventory.vue?vue&type=template&id=961e8936&scoped=true&"
import script from "./QRCodeScannerForInventory.vue?vue&type=script&lang=js&"
export * from "./QRCodeScannerForInventory.vue?vue&type=script&lang=js&"
import style0 from "./QRCodeScannerForInventory.vue?vue&type=style&index=0&id=961e8936&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961e8936",
  null
  
)

export default component.exports